{
  "type": "object",
  "properties": {
    "IntendedFor": { "type": "string", "minLength": 1 },
    "FiducialsDescription": { "type": "string", "minLength": 1 },
    "FiducialsCoordinates": {
      "$ref": "common_definitions.json#/definitions/LandmarkCoordinates"
    },
    "FiducialsCoordinateSystem": {
      "anyOf": [
        { "$ref": "common_definitions.json#/definitions/MEGCoordSys" },
        { "$ref": "common_definitions.json#/definitions/EEGCoordSys" },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateCoordSys"
        },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateDeprecatedCoordSys"
        }
      ]
    },
    "FiducialsCoordinateSystemDescription": {
      "type": "string",
      "minLength": 1
    },
    "FiducialsCoordinateUnits": {
      "$ref": "common_definitions.json#/definitions/CoordUnits"
    },
    "NIRSCoordinateSystem": {
      "anyOf": [
        { "$ref": "common_definitions.json#/definitions/MEGCoordSys" },
        { "$ref": "common_definitions.json#/definitions/EEGCoordSys" },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateCoordSys"
        },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateDeprecatedCoordSys"
        }
      ]
    },
    "NIRSCoordinateUnits": {
      "$ref": "common_definitions.json#/definitions/CoordUnits"
    },
    "NIRSCoordinateSystemDescription": { "type": "string", "minLength": 1 },
    "AnatomicalLandmarkCoordinates": {
      "$ref": "common_definitions.json#/definitions/LandmarkCoordinates"
    },
    "AnatomicalLandmarkCoordinateSystem": {
      "anyOf": [
        { "$ref": "common_definitions.json#/definitions/MEGCoordSys" },
        { "$ref": "common_definitions.json#/definitions/EEGCoordSys" },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateCoordSys"
        },
        {
          "$ref": "common_definitions.json#/definitions/StandardTemplateDeprecatedCoordSys"
        }
      ]
    },
    "AnatomicalLandmarkCoordinateUnits": {
      "$ref": "common_definitions.json#/definitions/CoordUnits"
    },
    "AnatomicalLandmarkCoordinateSystemDescription": {
      "type": "string",
      "minLength": 1
    },
    "NIRSCoordinateProcessingDescription": { "type": "string", "minLength": 1 }
  },
  "required": ["NIRSCoordinateSystem", "NIRSCoordinateUnits"],
  "additionalProperties": false,
  "allOf": [
    {
      "$ref": "#/dependency-definitions/if-NIRSCoordinateSystem-is-Other-then-Description-is-required"
    },
    {
      "$ref": "#/dependency-definitions/if-FiducialsCoordinateSystem-is-Other-then-Description-is-required"
    },
    {
      "$ref": "#/dependency-definitions/if-AnatomicalLandmarkCoordinateSystem-is-Other-then-Description-is-required"
    }
  ],
  "dependency-definitions": {
    "if-NIRSCoordinateSystem-is-Other-then-Description-is-required": {
      "if": {
        "type": "object",
        "properties": {
          "NIRSCoordinateSystem": { "const": "Other" }
        },
        "required": ["NIRSCoordinateSystem"]
      },
      "then": { "required": ["NIRSCoordinateSystemDescription"] }
    },
    "if-FiducialsCoordinateSystem-is-Other-then-Description-is-required": {
      "if": {
        "type": "object",
        "properties": {
          "FiducialsCoordinateSystem": { "const": "Other" }
        },
        "required": ["FiducialsCoordinateSystem"]
      },
      "then": { "required": ["FiducialsCoordinateSystemDescription"] }
    },
    "if-AnatomicalLandmarkCoordinateSystem-is-Other-then-Description-is-required": {
      "if": {
        "type": "object",
        "properties": {
          "AnatomicalLandmarkCoordinateSystem": { "const": "Other" }
        },
        "required": ["AnatomicalLandmarkCoordinateSystem"]
      },
      "then": { "required": ["AnatomicalLandmarkCoordinateSystemDescription"] }
    }
  }
}
